module.exports = __webpack_public_path__ + "img/SmartCone-Oranje.51f53dfd.png";